import requests from "./httpService";

const DayRentalPeriodicHikeDayServices = {
  getAllDayRentalPeriodicHikeDay: async (body) => {
    return requests.get(`/dayRentalPeriodicHikeDay/`);
  },

  addDayRentalPeriodicHikeDay: async (body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
    return requests.post(`/dayRentalPeriodicHikeDay/add`, formattedBody);
  },
  getDayRentalPeriodicHikeDayById: async (id) => {

    return requests.get(`/dayRentalPeriodicHikeDay/${id}`);
  },

  updateDayRentalPeriodicHikeDay: async (id, body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
    return requests.put(`/dayRentalPeriodicHikeDay/update/${id}`, formattedBody);
  },

  deleteDayRentalPeriodicHikeDay: async (id) => {
    return requests.delete(`/dayRentalPeriodicHikeDay/delete/${id}`);
  },
};

export default DayRentalPeriodicHikeDayServices;
